<mat-dialog-content [formGroup]="form">
	<div fxLayoutGap="5px" class="margin-top-10 header">
		<div></div>
		<div>
			<div fxLayoutGap="5px" fxLayout.xs="row">
				<button
					*ngIf="!cancel"
					class="form-button"
					type="button"
					color="grey"
					mat-raised-button
					(click)="navigate()"
				>
					Back to List
				</button>
				<button
					*ngIf="isDelete && !isArchived"
					class="form-button"
					color="blue"
					type="button"
					mat-raised-button
					(click)="deleteModel()"
				>
					Delete
				</button>
				<button
					*ngIf="cancel"
					class="form-button"
					color="blue"
					type="button"
					mat-raised-button
					(click)="navigate()"
				>
					Cancel
				</button>
				<button
					*ngIf="saveNew"
					class="form-button"
					color="blue"
					type="button"
					(click)="createNewAircraftModel()"
					mat-raised-button
				>
					Save New
				</button>
				<button
					*ngIf="saveChanges"
					class="form-button"
					color="blue"
					type="button"
					mat-raised-button
					(click)="saveChangesClicked()"
				>
					Save Changes
				</button>
			</div>
		</div>
	</div>
	<mat-card class="details">
		<mat-card-title id="AIRCRAFT_MODELS_DETAILS_TITLE">Details</mat-card-title>
		<hr />
		<mat-card-content class="card-content">
			<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
				<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
					<input
						required
						(keyup)="toggleButtons()"
						formControlName="name"
						matInput
						placeholder="Name"
						id="AIRCRAFT_MODELS_NAME"
						name="name"
						maxLength="100"
						#characterCountHintExample
					/>
				</mat-form-field>
			</div>
		</mat-card-content>
	</mat-card>
</mat-dialog-content>
